var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[(!_vm.isHelp)?_c('v-btn',{staticClass:"mr-1",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.$router.push('/help')}}},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v(" mdi-help-circle-outline ")])],1):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }